module.exports = __webpack_public_path__ + "img/american.a1e52df6.svg";